import { Link } from "react-router-dom"

function Experiments() {
    return (
        <section className="courses-three section-space2" id="courses">
            <div className="container">
                <div className="sec-title sec-title--center wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="00ms">
                    <h6 className="sec-title__tagline">Darslar</h6>
                    <h3 className="sec-title__title"><span className="sec-title__title__shape">MUHIM</span> <span className="sec-title__title__text">DARSLAR</span></h3>
                </div>
                <div className="row gutter-y-30">
                    <div className="col-lg-6">
                        <Link to="/experiment/usa">
                            <div className="course-card course-card--two wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="00ms">
                                <div className="course-card__image">
                                    <img src="/assets/images/usa2_flag.jpg" alt="AQSH tajribasi" />
                                </div>
                                <div className="course-card__content">
                                    <div className="course-card__content__top">
                                        <div className="course-card__category">Xalqaro</div>
                                    </div>
                                    <h3 className="course-card__title">AQSH tajribasi</h3>
                                    <div className="course-card__info">
                                        <div className="course-card__lessons">
                                            <span className="course-card__lessons__icon">
                                                <i className="icon-open-book"></i>
                                            </span>
                                            12 metodlar
                                        </div>
                                    </div>
                                    <div className="course-card__ratings">
                                        <div className="eduhive-ratings">
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                    <div className="col-lg-6">
                        <Link to="/experiment/germany">
                            <div className="course-card course-card--two wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="00ms">
                                <div className="course-card__image">
                                    <img src="/assets/images/germany2_flag.jpg" alt="AQSH tajribasi" />
                                </div>
                                <div className="course-card__content">
                                    <div className="course-card__content__top">
                                        <div className="course-card__category">Xalqaro</div>
                                    </div>
                                    <h3 className="course-card__title">Germaniya tajribasi</h3>
                                    <div className="course-card__info">
                                        <div className="course-card__lessons">
                                            <span className="course-card__lessons__icon">
                                                <i className="icon-open-book"></i>
                                            </span>
                                            13 metodlar
                                        </div>
                                    </div>
                                    <div className="course-card__ratings">
                                        <div className="eduhive-ratings">
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                    <div className="col-lg-6">
                        <Link to="/experiment/korea">
                            <div className="course-card course-card--two wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="00ms">
                                <div className="course-card__image">
                                    <img src="/assets/images/korea2_flag.jpg" alt="AQSH tajribasi" />
                                </div>
                                <div className="course-card__content">
                                    <div className="course-card__content__top">
                                        <div className="course-card__category">Xalqaro</div>
                                    </div>
                                    <h3 className="course-card__title">Koreya tajribasi</h3>
                                    <div className="course-card__info">
                                        <div className="course-card__lessons">
                                            <span className="course-card__lessons__icon">
                                                <i className="icon-open-book"></i>
                                            </span>
                                            25 metodlar
                                        </div>
                                    </div>
                                    <div className="course-card__ratings">
                                        <div className="eduhive-ratings">
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                    <div className="col-lg-6">
                        <Link to="/experiment/russia">
                            <div className="course-card course-card--two wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="00ms">
                                <div className="course-card__image">
                                    <img src="/assets/images/russia2_flag.jpg" alt="AQSH tajribasi" />
                                </div>
                                <div className="course-card__content">
                                    <div className="course-card__content__top">
                                        <div className="course-card__category">Xalqaro</div>
                                    </div>
                                    <h3 className="course-card__title">Rossiya tajribasi</h3>
                                    <div className="course-card__info">
                                        <div className="course-card__lessons">
                                            <span className="course-card__lessons__icon">
                                                <i className="icon-open-book"></i>
                                            </span>
                                            25 metodlar
                                        </div>
                                    </div>
                                    <div className="course-card__ratings">
                                        <div className="eduhive-ratings">
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
            <img src="/assets/images/courses-shape-3-1.png" alt="shape" className="courses-three__shape-one" />
            <img src="/assets/images/courses-shape-3-2.png" alt="shape" className="courses-three__shape-two" />
            <div className="courses-three__box-one"></div>
            <div className="courses-three__box-two"></div>
        </section >
    )
}

export default Experiments